import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CaretRight } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import {
  setEnrollmentContext,
  selectPreviousEnrollmentContext,
} from 'theSource/features/Home/components/EnrollmentBanner/services';
import { ListItemInfo } from 'theSource/components';
import { isValidHttpsUrl } from 'theSource/utils';
import { useContentSettingsQuery } from 'theSource/queries';
import { PsButtonTuner } from 'stencilSetup';

import './scss/AdminOptions.css';

// export interface AdminOptionsProps {}

declare const bootstrap: any;

export const AdminOptions: FC = () => {
  const { t } = useTranslation('enrollment.navigation');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const previousEnrollmentContextType = useSelector(
    selectPreviousEnrollmentContext
  );

  const { contentSettings } = useContentSettingsQuery({
    enabled: true,
  });

  const allowEarlyCheckout = contentSettings?.allow_early_checkout;
  const adminHomePageLink = contentSettings
    ? contentSettings.subscriber_admin_url
    : '';

  const proceedToCheckoutRoute: ListItemInfo = {
    name: 'navigation.additional:admin.proceedToCheckout',
    handleClick: () => {
      dispatch(setEnrollmentContext(previousEnrollmentContextType));
      navigate('/enrollment/review?earlyCheckout=true'); //same review page view but different confirm api
      document.documentElement.classList.remove('main-nav-open');
    },
  };

  const adminHomePage: ListItemInfo = {
    name: 'navigation.additional:admin.home',
    handleClick: () => {
      dispatch(setEnrollmentContext(''));
      if (adminHomePageLink.startsWith('http')) {
        window.location.href = adminHomePageLink; // External navigation
      }
    },
  };

  const resetEnrollment: ListItemInfo = {
    name: 'navigation.additional:admin.resetEnrollment',
    handleClick: () => {
      const dialog = new bootstrap.Modal(
        document.getElementById('reset-enrollment-modal')
      );
      dialog.show();
    },
  };

  let adminItems: ListItemInfo[] = [];

  adminItems = isValidHttpsUrl(adminHomePageLink) ? [adminHomePage] : [];
  adminItems = [...adminItems, resetEnrollment];
  if (allowEarlyCheckout && previousEnrollmentContextType !== '') {
    adminItems = [...adminItems, proceedToCheckoutRoute];
  }

  const adminRouteEntry = ['admin', adminItems] as [string, ListItemInfo[]];

  const navRoutesEntries = adminRouteEntry[1].map(
    (route: any, index: number) => {
      return (
        <button
          key={index}
          className={`dropdown-item d-flex align-items-center py-2 ${index !== adminRouteEntry[1].length - 1 ? 'border-bottom' : ''}`}
          onClick={route.handleClick}
        >
          <span className="flex-grow-1 mr-4">{t(route.name)}</span>
          <CaretRight
            className="caret-icon"
            size={16}
            weight="bold"
            aria-hidden="true"
            role="presentation"
          />
        </button>
      );
    }
  );

  //         <div><hr className="dropdown-divider my-0" /></div>

  return (
    <PsButtonTuner
      data-testid="admin-options-button"
      buttonId="admin-options"
      level="tertiary"
      label={t('navigation.additional:admin.title')}
      icon="user-circle ph-duotone"
      rootClass="dropdown-options"
      dropdown={true}
    >
      <div className="dropdown-menu py-0">{navRoutesEntries}</div>
    </PsButtonTuner>
  );
};
